// extracted by mini-css-extract-plugin
export default {"checkbox":"checkbox_checkbox__Ilsfh","input":"checkbox_input__Uv7jg","text":"checkbox_text__iNTeH"};